import { render, staticRenderFns } from "./lead-list.vue?vue&type=template&id=588ad742&scoped=true&"
import script from "./lead-list.vue?vue&type=script&lang=js&"
export * from "./lead-list.vue?vue&type=script&lang=js&"
import style0 from "./lead-list.vue?vue&type=style&index=0&id=588ad742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ad742",
  null
  
)

export default component.exports